{
  "icons": [
    {
      "src": "./favicon-192.png",
      "type": "image/png",
      "sizes": "192x192"
    },
    {
      "src": "./favicon-512.png",
      "type": "image/png",
      "sizes": "512x512"
    }
  ]
}
